// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import uploader from 'vue-simple-uploader'
import md5 from 'js-md5'
import i18n from './lang' // internationalization
import './permission' // permission control
import moment from 'moment'; // 时间处理
Vue.prototype.$moment = moment;
Vue.use(ElementUI)
Vue.use(uploader)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.use({
  i18n: (key, value) => i18n.t(key, value)
})
/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js